import {inject, Injectable} from '@angular/core';
import {ChatsWithPollingParams, MessagesWithPollingParams} from "../types/polling.types";
import {TelegramApiService} from "./telegram-api.service";
import {MessagesPollingService} from "./messages-polling.service";
import {ChatsPollingService} from "./chats-polling.service";

@Injectable({
  providedIn: 'root'
})
export class TelegramPollingService {
  private telegramApiService: TelegramApiService = inject(TelegramApiService);
  private messagesPollingService: MessagesPollingService = inject(MessagesPollingService);
  private chatsPollingService: ChatsPollingService = inject(ChatsPollingService);

  public getMessagesWithPolling({ params, intervalMs, callback }: MessagesWithPollingParams): void {
    const requestFn = () => this.telegramApiService.getMessages(params);
    this.messagesPollingService.startPolling({ intervalMs, requestFn, callback });
  }

  public getChatsWithPolling({ params, intervalMs, callback }: ChatsWithPollingParams): void {
    const requestFn = () => this.telegramApiService.getMainChats(params);
    this.chatsPollingService.startPolling({ intervalMs, requestFn, callback });
  }
}
